import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { LoginService } from 'src/app/services/login.service';
import { LoginResponse } from 'src/app/models/Masters/userMaster';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  private subscription: Subscription[] = [];
  reqNo: any;
  display = false;
  forgotPasswordForm: FormGroup;
  formSubmitted = false;
  constructor(private route: ActivatedRoute, private fb: FormBuilder, private loginService: LoginService,
    private messageService: MessageService, private router: Router) {
    this.initForm();
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.reqNo = params.reqNo;
    });
    if (this.reqNo) {
      this.checkRequestNo(this.reqNo);
    } else {
    }
  }
  initForm() {
    this.forgotPasswordForm = this.fb.group({
      emailId: [null, [Validators.required, Validators.email]],
      reqNo: [null],
      newPassword: [null, [Validators.required, Validators.minLength(6)]],
      confirmPassword: [null, [Validators.required]],
    });
  }
  get f() { return this.forgotPasswordForm.controls; }
  ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
  checkRequestNo(reqNo: any) {
    this.subscription.push(this.loginService.checkRequestNo(reqNo).subscribe((response: LoginResponse) => {
      if (response.responseCode === '200') {
        this.display = true;
      } else {
        this.router.navigateByUrl('/404');
      }
    })
    );
  }
  onSubmit() {    
    this.formSubmitted = true;
    if (this.forgotPasswordForm.invalid) {
      return;
    }
    const form = { ...this.forgotPasswordForm.value };
    if (form.newPassword !== form.confirmPassword) {
      this.forgotPasswordForm.controls.confirmPassword.setErrors({ matchPassword: true });
      return;
    }
    form.reqNo = this.reqNo;
    this.resetPassword(form);
  }
  resetPassword(form: any) {
    this.subscription.push(this.loginService.resetPassword(form).subscribe((response: LoginResponse) => {
      if (response.responseCode === '200') {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: response.responseMessage });
        this.router.navigateByUrl('/login');
      } else {
        this.messageService.add({ severity: 'warn', summary: 'Oops!', detail: response.responseMessage });
      }
    })
    );
  }

}
